import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "../components/PolicyLayout";

const SECTIONS = [
  { id: "area",         label: "Delivery Area"      },
  { id: "timeframe",    label: "Timeframe"           },
  { id: "cutoff",       label: "Cutoff Times"        },
  { id: "process",      label: "Delivery Process"    },
  { id: "verification", label: "Order Verification"  },
  { id: "minimum",      label: "Minimum Orders"      },
  { id: "contact",      label: "Contact"             },
];

export default function ShippingPolicy() {
  return (
    <PolicyLayout
      title="Shipping Policy"
      description="Khoja Distributions shipping and delivery policy — covering DFW and surrounding Texas areas with 1–2 business day delivery."
      canonical="https://www.khojadistributions.com/shipping"
      sections={SECTIONS}
      relatedLinks={
        <Link to="/support" className="text-sm text-accent font-bold hover:underline">
          ← Submit a support request
        </Link>
      }
    >
      <PolicySection id="area" title="Delivery Area">
        <p>Khoja Distributions delivers across the DFW metroplex and to many surrounding cities and towns throughout Texas. We service a wide geographic area including, but not limited to, Dallas, Fort Worth, Arlington, Garland, Irving, Mesquite, Plano, Frisco, McKinney, Denton, and many smaller communities throughout North and Central Texas.</p>
        <p>If you are unsure whether we deliver to your location, please contact us before placing your order at <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a> or <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a>.</p>
      </PolicySection>

      <PolicySection id="timeframe" title="Delivery Timeframe">
        <p>Orders are typically delivered within <strong>1–2 business days</strong> of order placement, depending on your location and order volume. Business days are Monday through Saturday, excluding major holidays.</p>
        <p>Delivery estimates are not guaranteed and may be affected by high order volume, weather conditions, vehicle availability, or other factors outside our control. We will contact you if there is a significant delay with your order.</p>
      </PolicySection>

      <PolicySection id="cutoff" title="Order Cutoff Times">
        <p>Orders placed before <strong>12:00 PM (noon)</strong> on a business day are generally scheduled for next-day delivery. Orders placed after noon or on weekends will be scheduled for the following business day, subject to route availability.</p>
      </PolicySection>

      <PolicySection id="process" title="Delivery Process">
        <p>Our drivers will deliver your order directly to your place of business. Please ensure that someone is available at the delivery address to receive and sign for the order during business hours.</p>
        <p>If no one is available to receive the delivery, we will attempt to contact you. Undeliverable orders may be rescheduled, and a redelivery fee may apply at our discretion.</p>
      </PolicySection>

      <PolicySection id="verification" title="Order Verification">
        <p>Upon delivery, please inspect your order carefully before signing. If you notice any damaged, missing, or incorrect items, note this at the time of delivery and contact us within <strong>48 hours</strong> with photos of the issue so we can resolve it promptly.</p>
        <p>Claims submitted after 48 hours of delivery may not be eligible for replacement or credit.</p>
      </PolicySection>

      <PolicySection id="minimum" title="Minimum Orders">
        <p>Minimum order requirements may apply depending on your account type and delivery location. Contact us for details specific to your account.</p>
      </PolicySection>

      <PolicySection id="contact" title="Contact Us">
        <p>For shipping-related questions, call or text us during business hours:</p>
        <p>
          <strong>Khoja Distributions</strong><br />
          Phone: <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a><br />
          Email: <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a><br />
          Hours: Monday–Saturday, 10am–6pm
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
